import InviteRedirect from './InviteRedirect';
export default InviteRedirect;
